var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDownloads = function SvgDownloads(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 19,
    viewBox: "0 0 32 19"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#dac7fa",
    d: "M24.355 3.237 16.1 11.492 7.843 3.237zM16.1 14.581c.713 0 1.425-.272 1.968-.814l8.781-8.78a2.77 2.77 0 0 0 .603-3.032 2.77 2.77 0 0 0-2.57-1.718H7.317a2.77 2.77 0 0 0-2.57 1.718 2.77 2.77 0 0 0 .603 3.031l8.782 8.781a2.77 2.77 0 0 0 1.967.814zM7.471 2.865l.001.001"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#dac7fa",
    d: "M27.196 18.93H5.002a4.564 4.564 0 0 1-4.559-4.56V9.876a1.5 1.5 0 0 1 3 0v4.494c0 .86.7 1.56 1.56 1.56h22.193c.86 0 1.56-.7 1.56-1.56V9.876a1.5 1.5 0 1 1 3 0v4.494a4.564 4.564 0 0 1-4.56 4.56"
  })));
};
export default SvgDownloads;